import Swiper from 'swiper';
import { Navigation, A11y } from 'swiper/modules';
import { withFocusManagement } from 'helpers/swiper/swiperFocusManagement';
import { fancyboxOptions } from 'helpers/fancybox/fancyboxOptions.js';

export const productImageSlider = () => {
    // Setup main image slider
    const swiperEl = document.querySelector('.product-image-swiper');
    const thumbEls = document.querySelectorAll('.image-thumbs .thumb');
    const slideAnnouncerEl = document.querySelector('.product-image-slide-announcer');

    // Announce the active slide (position + the matching thumb's already translated label)
    const _announceActiveSlide = (activeIndex) => {
        if (!slideAnnouncerEl) {
            return;
        }
        const activeThumbEl = Array.from(thumbEls).find(
            (thumbEl) => parseInt(thumbEl.dataset.thumbIndex, 10) === activeIndex
        );
        // thumb's aria-label already includes the "x / y" position prefix
        slideAnnouncerEl.textContent = activeThumbEl?.getAttribute('aria-label') ?? '';
    };

    // Update image counter (shown on small screens instead of thumbs)
    const _updateImageCounter = (currentNumber) => {
        let element;
        if (swiperEl) {
            element = swiperEl.parentElement.querySelector('#image-counter .currentSlide');
        }

        if (element) {
            element.innerHTML = currentNumber;
        }
    };

    // Highlight the thumb matching the active slide
    const _setActiveThumb = (activeIndex) => {
        thumbEls.forEach((thumbEl) => {
            const isActive = parseInt(thumbEl.dataset.thumbIndex, 10) === activeIndex;
            thumbEl.classList.toggle('active', isActive);
            thumbEl.setAttribute('aria-current', isActive);
        });
    };

    if (swiperEl) {
        // A11y module overwrites the nav buttons' aria-label, keep the (translated) labels already in the markup
        const prevSlideMessage = swiperEl.querySelector('.swiper-button-prev')?.getAttribute('aria-label');
        const nextSlideMessage = swiperEl.querySelector('.swiper-button-next')?.getAttribute('aria-label');

        // new Swiper
        const swiperConfig = withFocusManagement({
            modules: [Navigation, A11y],
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            a11y: {
                prevSlideMessage,
                nextSlideMessage
            },
            slidesPerView: 1
        });
        const mainImageSlider = new Swiper('.product-image-swiper', swiperConfig);

        mainImageSlider.on('slideChange', (swiper) => {
            _updateImageCounter(swiper.activeIndex + 1);
            _setActiveThumb(swiper.activeIndex);
            _announceActiveSlide(swiper.activeIndex);
        });

        thumbEls.forEach((thumbEl) => {
            thumbEl.addEventListener('click', () => {
                const index = parseInt(thumbEl.dataset.thumbIndex, 10);
                mainImageSlider.slideTo(index);
            });
        });

        _setActiveThumb(mainImageSlider.activeIndex);
    }

    // Meer afbeeldingen tonen zonder slider
    // Eventlisteners for show more images
    const _addEventListeners = () => {
        const moreImagesEl = document.querySelector('#more-images-button');
        const moreImagesBtn = document.querySelector('#more-images-button-text');
        const productImage = document.querySelectorAll('.other-product-images');

        document.querySelectorAll('.thumb-more-overlay[data-open-fancybox-at]').forEach((overlay) => {
            overlay.addEventListener('click', (e) => {
                e.stopPropagation();
                const index = parseInt(overlay.dataset.openFancyboxAt, 10) || 0;
                const anchors = [...document.querySelectorAll('[data-fancybox="productImages"]')];
                if (anchors.length) {
                    // Fancybox is heavy, fetch it (and its CSS) on demand (see default.bundle.js)
                    Promise.all([
                        import('@fancyapps/ui'),
                        import('../../../../../scss/vendors/fancybox-lazy.scss')
                    ]).then(([{ Fancybox }]) => {
                        Fancybox.fromNodes(anchors, { ...fancyboxOptions(), startIndex: index });
                    });
                }
            });
        });

        if (moreImagesEl) {
            moreImagesEl.addEventListener('click', () => {
                moreImagesBtn.querySelector('.show-more').classList.toggle('d-none');
                moreImagesBtn.querySelector('.show-less').classList.toggle('d-none');
                // Toggle d-none on button click
                productImage.forEach((productImage) => {
                    productImage.classList.toggle('d-none');
                    if (productImage.classList.contains('d-none')) {
                        window.scrollTo({ top: 10, behavior: 'smooth' });
                    }
                });
            });
        }
    };
    _addEventListeners();
};
